import type { SVGProps } from 'react'
export default function OrangeArrow(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 25" fill="none" {...props}>
      <path
        fill="#FF620F"
        fillRule="evenodd"
        d="m13.707 6.01 6.65 6.651-6.094 7.203-1.526-1.292 4.107-4.854H4v-2h12.586l-4.293-4.293z"
        clipRule="evenodd"
      />
    </svg>
  )
}
